// extracted by mini-css-extract-plugin
export default {"container":"Favorite_container__l2sZV","imageContainer":"Favorite_imageContainer__If+lG"};